export default __webpack_public_path__ + "static/media/ci-antigua-ejemplo-front.2e713f48.png";